import React from 'react'
import { GetMonthNameByNumber } from './Helper/GetMonthNameByNumber';
import { useHistory } from "react-router-dom";
import { LinearProgress } from '@mui/material';
import { FormatMoney } from '../../../Helpers/FormatNumber';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CellTowerIcon from '@mui/icons-material/CellTower';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StarsIcon from '@mui/icons-material/Stars';

export const TablaVendedorDetalleUnidades = ({ boxstate, data, initialStateboxfiltros }) => {

    const history = useHistory();

    const formatPorcentaje = (real, objetivo) => {
        if (objetivo === 0 && real === 0) {
            return null;
        }

        if (objetivo === 0) {
            return 100;
        }

        const porcentaje = (real / objetivo) * 100;

        return Math.min(porcentaje, 100);
    };

    const getBarColor = (porcentaje) => {
        if (porcentaje <= 60) {
            return "#f44336";
        } else if (porcentaje > 60 && porcentaje < 80) {
            return "#ffc107";
        } else {
            return "#035917";
        }
    };

    const capitalizeWords = (str) => {
        return str
            ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
    };

    const onDetalleMensual = (linea) => {

        if (linea.toLowerCase() === "garantia extendida") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "GE",
            });
        }
        if (linea.toLowerCase() === "poliza mantenimiento") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "PM",
            });
        }
        else {
            // Verificar si hay datos en localStorage para 'DatosFiltro'
            const datosFiltro = localStorage.getItem("DatosFiltro");

            // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
            const data = {
                boxstate: datosFiltro ? initialStateboxfiltros() : boxstate,
                linea,
            };

            // Eliminar el item 'DatosFiltro' del localStorage
            localStorage.removeItem("DatosFiltro");

            // Navegar a la ruta especificada, pasando el objeto data en el estado
            history.push({
                pathname: "/Ventas/DetalleFacturacionMensual",
                state: data,
            });
        }
    };


    const onDetalleAcumulado = (linea) => {
        if (linea.toLowerCase() === "garantia extendida") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "GE",
            });
        }
        else if (linea.toLowerCase() === "poliza mantenimiento") {
            history.push({
                pathname: "/Ventas/PaqueteServicio",
                state: "PM",
            });
        }
        else {
            // Verificar si hay datos en localStorage para 'DatosFiltro'
            const datosFiltro = localStorage.getItem("DatosFiltro");

            // Si hay datos en localStorage, usar initialStateboxfiltros(); de lo contrario, usar boxstate
            const data = {
                boxstate: datosFiltro ? initialStateboxfiltros() : boxstate,
                linea,
            };

            // Eliminar el item 'DatosFiltro' del localStorage
            localStorage.removeItem("DatosFiltro");

            history.push({
                pathname: "/Ventas/DetalleFacturacionAcumulado",
                state: data,
            });
        }
    };

    //Maquinaria
    const maquinariaFiltrada = data.filter((item) =>
        ["tractores", "implementos", "jardineros"].includes(item.linea.toLowerCase())
    );

    const porcentajesMensualesMaquinaria = [];
    const coloresMensualesMaquinaria = [];

    for (let mes = 1; mes <= 12; mes++) {
        const unidadesKey = `unidades_${mes}`;
        const objetivoKey = `objetivo_${mes}`;

        const totalImporte = maquinariaFiltrada.reduce((acc, item) => acc + (item[unidadesKey] || 0), 0);
        const totalObjetivo = maquinariaFiltrada.reduce((acc, item) => acc + (item[objetivoKey] || 0), 0);

        const porcentaje = formatPorcentaje(totalImporte, totalObjetivo);
        const color = getBarColor(porcentaje);

        porcentajesMensualesMaquinaria.push(porcentaje);
        coloresMensualesMaquinaria.push(color);
    }

    // const maquinariaFiltrada = data.filter((item) =>
    //     ["tractores", "implementos", "jardineros"].includes(item.linea.toLowerCase())
    // );

    // const totalMaquinariaImporte1 = maquinariaFiltrada.reduce((acc, item) => acc + item.unidades_1, 0);
    // const totalMaquinariaObjetivo1 = maquinariaFiltrada.reduce((acc, item) => acc + item.objetivo_1, 0);
    // const totalMaquinariaImporte2 = maquinariaFiltrada.reduce((acc, item) => acc + item.unidades_2, 0);
    // const totalMaquinariaObjetivo2 = maquinariaFiltrada.reduce((acc, item) => acc + item.objetivo_2, 0);

    // const porcentajeMensualMaquinaria1 = formatPorcentaje(
    //     totalMaquinariaImporte1,
    //     totalMaquinariaObjetivo1
    // );
    // const porcentajeMensualMaquinaria2 = formatPorcentaje(
    //     totalMaquinariaImporte2,
    //     totalMaquinariaObjetivo2
    // );
    // const barColorMensualMaquinaria1 = getBarColor(porcentajeMensualMaquinaria1);
    // const barColorAcumuladoMaquinaria2 = getBarColor(porcentajeMensualMaquinaria2);


    //Autoguiado
    const autoguiadoFiltrada = data.filter((item) =>
        ["autoguiado", "drones"].includes(item.linea.toLowerCase())
    );

    const porcentajesMensualesAutoguiado = [];
    const coloresMensualesAutoguiado = [];

    for (let mes = 1; mes <= 12; mes++) {
        const unidadesKey = `unidades_${mes}`;
        const objetivoKey = `objetivo_${mes}`;

        const totalImporte = autoguiadoFiltrada.reduce((acc, item) => acc + (item[unidadesKey] || 0), 0);
        const totalObjetivo = autoguiadoFiltrada.reduce((acc, item) => acc + (item[objetivoKey] || 0), 0);

        const porcentaje = formatPorcentaje(totalImporte, totalObjetivo);
        const color = getBarColor(porcentaje);

        porcentajesMensualesAutoguiado.push(porcentaje);
        coloresMensualesAutoguiado.push(color);
    }


    //Usados
    const usadosFiltrada = data.filter((item) =>
        ["trilladoras seminuevas", "tractores seminuevos"].includes(item.linea.toLowerCase())
    );

    const porcentajesMensualesUsados = [];
    const coloresMensualesUsados = [];

    for (let mes = 1; mes <= 12; mes++) {
        const unidadesKey = `unidades_${mes}`;
        const objetivoKey = `objetivo_${mes}`;

        const totalImporte = usadosFiltrada.reduce((acc, item) => acc + (item[unidadesKey] || 0), 0);
        const totalObjetivo = usadosFiltrada.reduce((acc, item) => acc + (item[objetivoKey] || 0), 0);

        const porcentaje = formatPorcentaje(totalImporte, totalObjetivo);
        const color = getBarColor(porcentaje);

        porcentajesMensualesUsados.push(porcentaje);
        coloresMensualesUsados.push(color);
    }
    //Posventa
    const posventaFiltrada = data.filter((item) =>
        ["garantia extendida", "poliza mantenimiento"].includes(item.linea.toLowerCase())
    );

    const porcentajesMensualesPosventa = [];
    const coloresMensualesPosventa = [];

    for (let mes = 1; mes <= 12; mes++) {
        const unidadesKey = `unidades_${mes}`;
        const objetivoKey = `objetivo_${mes}`;

        const totalImporte = posventaFiltrada.reduce((acc, item) => acc + (item[unidadesKey] || 0), 0);
        const totalObjetivo = posventaFiltrada.reduce((acc, item) => acc + (item[objetivoKey] || 0), 0);

        const porcentaje = formatPorcentaje(totalImporte, totalObjetivo);
        const color = getBarColor(porcentaje);

        porcentajesMensualesPosventa.push(porcentaje);
        coloresMensualesPosventa.push(color);
    }


    //Producto Aliado
    const aliadoFiltrado = data.filter(item => item.linea.toLowerCase() === "producto aliado");

    const porcentajesMensualesAliados = [];
    const coloresMensualesAliados = [];

    for (let mes = 1; mes <= 12; mes++) {
        const unidadesKey = `unidades_${mes}`;
        const objetivoKey = `objetivo_${mes}`;

        const totalImporte = aliadoFiltrado.reduce((acc, item) => acc + (item[unidadesKey] || 0), 0);
        const totalObjetivo = aliadoFiltrado.reduce((acc, item) => acc + (item[objetivoKey] || 0), 0);

        const porcentaje = formatPorcentaje(totalImporte, totalObjetivo);
        const color = getBarColor(porcentaje);

        porcentajesMensualesAliados.push(porcentaje);
        coloresMensualesAliados.push(color);
    }

    return (
        <div className='tabla-vendedor-detalle-unidades-scorecard scroll'>
            <table cellPadding={0} cellSpacing={0} >
                <thead>
                    <tr>
                        <th colSpan={2}></th>
                        <th colSpan={3}>
                            <div>Enero</div>
                        </th>
                        <th colSpan={3}>
                            <div>Febrero</div>
                        </th>
                        <th colSpan={3}>
                            <div>Marzo</div>
                        </th>
                        <th colSpan={3}>
                            <div>Abril</div>
                        </th>
                        <th colSpan={3}>
                            <div>Mayo</div>
                        </th>
                        <th colSpan={3}>
                            <div>Junio</div>
                        </th>
                        <th colSpan={3}>
                            <div>Julio</div>
                        </th>
                        <th colSpan={3}>
                            <div>Agosto</div>
                        </th>
                        <th colSpan={3}>
                            <div>Septiembre</div>
                        </th>
                        <th colSpan={3}>
                            <div>Octubre</div>
                        </th>
                        <th colSpan={3}>
                            <div>Noviembre</div>
                        </th>
                        <th colSpan={3}>
                            <div>Diciembre</div>
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <div>Línea</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                        <th>
                            <div>Objetivo</div>
                        </th>
                        <th>
                            <div>Real</div>
                        </th>
                        <th>
                            <div>Alcance</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((score, index) => {
                        const porcentajeMensual = formatPorcentaje(
                            score.unidades_vendidas,
                            score.objetivo
                        );
                        const porcentajeAcumulado = formatPorcentaje(
                            score.unidades_vendidas_acumulado,
                            score.objetivo_acumulado
                        );
                        const barColorMensual = getBarColor(porcentajeMensual);
                        const barColorAcumulado = getBarColor(porcentajeAcumulado);

                        return (
                            <React.Fragment key={score.linea}>
                                {/* Total Maquinaria (ya existente) */}
                                {score.linea.toLowerCase() === "tractores" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <AgricultureIcon /> <strong>Maquinaria</strong>
                                            </div>
                                        </td>

                                        {Array.from({ length: 12 }).map((_, index) => {
                                            const mes = index + 1;
                                            const totalObjetivo = maquinariaFiltrada.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                                            const totalImporte = maquinariaFiltrada.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                                            const porcentaje = porcentajesMensualesMaquinaria[index];
                                            const barColor = coloresMensualesMaquinaria[index];

                                            return (
                                                <React.Fragment key={mes}>
                                                    <td style={{textAlign:'center'}}>{totalObjetivo}</td>
                                                    <td>{totalImporte}</td>
                                                    <td>
                                                        <span className="percentaje">
                                                            {totalObjetivo !== 0 || totalImporte !== 0
                                                                ? `${porcentaje.toFixed(0)}%`
                                                                : ""}
                                                        </span>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={porcentaje}
                                                            sx={{
                                                                height: 10,
                                                                borderRadius: 5,
                                                                backgroundColor: "#e0e0e0",
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: barColor,
                                                                },
                                                            }}
                                                        />
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                )}


                                {/* 🔽 NUEVA FILA: Total Agricultura de Precisión */}
                                {score.linea.toLowerCase() === "autoguiado" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <CellTowerIcon /> <strong>Agricultura de Precisión</strong>
                                            </div>
                                        </td>

                                        {Array.from({ length: 12 }).map((_, index) => {
                                            const mes = index + 1;
                                            const totalObjetivo = autoguiadoFiltrada.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                                            const totalImporte = autoguiadoFiltrada.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                                            const porcentaje = porcentajesMensualesAutoguiado[index];
                                            const barColor = coloresMensualesAutoguiado[index];

                                            return (
                                                <React.Fragment key={mes}>
                                                    <td style={{textAlign:'center'}}>{totalObjetivo}</td>
                                                    <td>{totalImporte}</td>
                                                    <td>
                                                        <span className="percentaje">
                                                            {totalObjetivo !== 0 || totalImporte !== 0
                                                                ? `${porcentaje.toFixed(0)}%`
                                                                : ""}
                                                        </span>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={porcentaje}
                                                            sx={{
                                                                height: 10,
                                                                borderRadius: 5,
                                                                backgroundColor: "#e0e0e0",
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: barColor,
                                                                },
                                                            }}
                                                        />
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                )}

                                {score.linea.toLowerCase() === "tractores seminuevos" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <AgricultureIcon /> <strong>Maquinaria Seminueva</strong>
                                            </div>
                                        </td>

                                        {Array.from({ length: 12 }).map((_, index) => {
                                            const mes = index + 1;
                                            const totalObjetivo = usadosFiltrada.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                                            const totalImporte = usadosFiltrada.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                                            const porcentaje = porcentajesMensualesUsados[index];
                                            const barColor = coloresMensualesUsados[index];

                                            return (
                                                <React.Fragment key={mes}>
                                                    <td style={{textAlign:'center'}}>{totalObjetivo}</td>
                                                    <td>{totalImporte}</td>
                                                    <td>
                                                        <span className="percentaje">
                                                            {totalObjetivo !== 0 || totalImporte !== 0
                                                                ? `${porcentaje.toFixed(0)}%`
                                                                : ""}
                                                        </span>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={porcentaje}
                                                            sx={{
                                                                height: 10,
                                                                borderRadius: 5,
                                                                backgroundColor: "#e0e0e0",
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: barColor,
                                                                },
                                                            }}
                                                        />
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                )}


                                {score.linea.toLowerCase() === "garantia extendida" && (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <StarsIcon /> <strong>Posventa</strong>
                                            </div>
                                        </td>

                                        {Array.from({ length: 12 }).map((_, index) => {
                                            const mes = index + 1;
                                            const totalObjetivo = posventaFiltrada.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                                            const totalImporte = posventaFiltrada.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                                            const porcentaje = porcentajesMensualesPosventa[index];
                                            const barColor = coloresMensualesPosventa[index];

                                            return (
                                                <React.Fragment key={mes}>
                                                    <td style={{textAlign:'center'}}>{totalObjetivo}</td>
                                                    <td>{totalImporte}</td>
                                                    <td>
                                                        <span className="percentaje">
                                                            {totalObjetivo !== 0 || totalImporte !== 0
                                                                ? `${porcentaje.toFixed(0)}%`
                                                                : ""}
                                                        </span>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={porcentaje}
                                                            sx={{
                                                                height: 10,
                                                                borderRadius: 5,
                                                                backgroundColor: "#e0e0e0",
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: barColor,
                                                                },
                                                            }}
                                                        />
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                )}

                                {score.linea.toLowerCase() === "producto aliado" ? (
                                    <tr className="importes-totales">
                                        <td colSpan={2} className='titulo-subtotales'>
                                            <div className='titulo-suntotal-div'>
                                                <StarsIcon /> <strong>Producto Aliado</strong>
                                            </div>
                                        </td>

                                        {Array.from({ length: 12 }).map((_, index) => {
                                            const mes = index + 1;
                                            const totalObjetivo = aliadoFiltrado.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                                            const totalImporte = aliadoFiltrado.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                                            const porcentaje = porcentajesMensualesAliados[index];
                                            const barColor = coloresMensualesAliados[index];

                                            return (
                                                <React.Fragment key={mes}>
                                                    <td style={{textAlign:'center'}}>{totalObjetivo}</td>
                                                    <td>{totalImporte}</td>
                                                    <td>
                                                        <span className="percentaje">
                                                            {totalObjetivo !== 0 || totalImporte !== 0
                                                                ? `${porcentaje.toFixed(0)}%`
                                                                : ""}
                                                        </span>
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={porcentaje}
                                                            sx={{
                                                                height: 10,
                                                                borderRadius: 5,
                                                                backgroundColor: "#e0e0e0",
                                                                "& .MuiLinearProgress-bar": {
                                                                    backgroundColor: barColor,
                                                                },
                                                            }}
                                                        />
                                                    </td>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                ) : (
                                    // Fila normal para cualquier otra línea
                                    <tr>
                                        <td className={`celda-seaparacion-titulo ${score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}`}></td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                        >{capitalizeWords(score.linea)}</td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            {score.objetivo_1}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            {score.unidades_1}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleMensual(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_1 !== 0 || score.objetivo_1 !== 0
                                                    ? `${formatPorcentaje(score.unidades_1, score.objetivo_1).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_1, score.objetivo_1)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorMensual,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_2}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_2}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_2 !== 0 || score.objetivo_2 !== 0
                                                    ? `${formatPorcentaje(score.unidades_2, score.objetivo_2).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_2, score.objetivo_2)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_3}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_3}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_3 !== 0 || score.objetivo_3 !== 0
                                                    ? `${formatPorcentaje(score.unidades_3, score.objetivo_3).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_3, score.objetivo_3)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_4}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_4}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_4 !== 0 || score.objetivo_4 !== 0
                                                    ? `${formatPorcentaje(score.unidades_4, score.objetivo_4).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_4, score.objetivo_4)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_5}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_5}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_5 !== 0 || score.objetivo_5 !== 0
                                                    ? `${formatPorcentaje(score.unidades_5, score.objetivo_5).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_5, score.objetivo_5)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_6}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_6}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_6 !== 0 || score.objetivo_6 !== 0
                                                    ? `${formatPorcentaje(score.unidades_6, score.objetivo_6).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_6, score.objetivo_6)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_7}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_7}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_7 !== 0 || score.objetivo_7 !== 0
                                                    ? `${formatPorcentaje(score.unidades_7, score.objetivo_7).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_7, score.objetivo_7)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_8}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_8}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_8 !== 0 || score.objetivo_8 !== 0
                                                    ? `${formatPorcentaje(score.unidades_8, score.objetivo_8).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_8, score.objetivo_8)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_9}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_9}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_9 !== 0 || score.objetivo_9 !== 0
                                                    ? `${formatPorcentaje(score.unidades_9, score.objetivo_9).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_9, score.objetivo_9)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_10}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_10}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_10 !== 0 || score.objetivo_10 !== 0
                                                    ? `${formatPorcentaje(score.unidades_10, score.objetivo_10).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_10, score.objetivo_10)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_11}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_11}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_11 !== 0 || score.objetivo_11 !== 0
                                                    ? `${formatPorcentaje(score.unidades_11, score.objetivo_11).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_11, score.objetivo_11)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.objetivo_12}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            {score.unidades_12}
                                        </td>
                                        <td
                                            className={score.linea.toLowerCase() === "jardineros" || score.linea.toLowerCase() === "drones" || score.linea.toLowerCase() === "trilladoras usadas" || score.linea.toLowerCase() === "poliza mantenimiento" ? "no-border" : "border"}
                                            onClick={() => onDetalleAcumulado(score.linea)}>
                                            <span className="percentaje">
                                                {score.unidades_12 !== 0 || score.objetivo_12 !== 0
                                                    ? `${formatPorcentaje(score.unidades_12, score.objetivo_12).toFixed(0)}%`
                                                    : ""}
                                            </span>
                                            <LinearProgress
                                                variant="determinate"
                                                value={formatPorcentaje(score.unidades_12, score.objetivo_12)}
                                                sx={{
                                                    height: 10,
                                                    borderRadius: 5,
                                                    backgroundColor: "#e0e0e0",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: barColorAcumulado,
                                                    },
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}

                            </React.Fragment>

                        );
                    })}

                    {/* 👇 Fila de totales generales */}
                    <tr className="importes-totales">
                        <td colSpan={2}>Importe Total</td>

                        {Array.from({ length: 12 }).map((_, index) => {
                            const mes = index + 1;
                            const objetivoTotal = data.reduce((acc, item) => acc + (item[`objetivo_${mes}`] || 0), 0);
                            const unidadesTotal = data.reduce((acc, item) => acc + (item[`unidades_${mes}`] || 0), 0);
                            const porcentaje = formatPorcentaje(unidadesTotal, objetivoTotal);
                            const barColor = getBarColor(porcentaje);

                            return (
                                <React.Fragment key={mes}>
                                    <td className='titulo-subtotal-segunda-columna'>{objetivoTotal}</td>
                                    <td>{unidadesTotal}</td>
                                    <td>
                                        <span className="percentaje">
                                            {objetivoTotal !== 0 || unidadesTotal !== 0 ? `${porcentaje.toFixed(0)}%` : ""}
                                        </span>
                                        <LinearProgress
                                            variant="determinate"
                                            value={porcentaje}
                                            sx={{
                                                height: 10,
                                                borderRadius: 5,
                                                backgroundColor: "#e0e0e0",
                                                "& .MuiLinearProgress-bar": {
                                                    backgroundColor: barColor,
                                                },
                                            }}
                                        />
                                    </td>
                                </React.Fragment>
                            );
                        })}
                    </tr>

                </tbody>
            </table >
        </div>
    )
}
